import gql from "graphql-tag";

export const getAuthenticationState = gql`
  query {
    authenticationState @client {
      authenticated
      selectedProject
      needsToOnboard
      uid
      darkMode
    }
  }
`;

export const getAuthenticationStateOptions = {
  name: "authenticationState",
};
